// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-option-value {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex: 1 1;
  height: 100%;
  box-sizing: border-box;
  overflow: scroll;
}
.modal-option-value-title {
  font-size: 1.25em;
  font-weight: bold;
}
.modal-option-value-container {
  flex: 1 1;
  margin-top: 2em;
  margin-inline: 2em;
  padding: 2em;
  border-radius: 1em;
  background-color: #fff;
}
.modal-option-value-form {
  display: flex;
  flex-direction: column;
}
.modal-option-value-form-layout {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1em;
}
.modal-option-value-form-radio-group {
  width: 100%;
  margin: 1em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.modal-option-value-form-radio {
  display: flex;
  justify-content: center;
  align-items: center;
}

.form-check {
  margin: 1em;
}

.link-content-container {
  width: 100%;
}

.modal-option-value-form-select {
  width: 100% !important;
}

.modal-header .form-action {
  margin-inline: 1em !important;
  width: 1em;
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/modalOptionForm/modalOptionForm.scss","webpack://./src/sass/globals/mixins.scss","webpack://./src/sass/globals/globals.scss"],"names":[],"mappings":"AAGA;ECFC,aAAA;EACA,uBDEc;ECDd,uBDCsB;EACtB,SAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AAAD;AAEC;EACC,iBAAA;EACA,iBAAA;AAAF;AAGC;EACC,SAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBEjBM;AFgBR;AAIC;EACC,aAAA;EACA,sBAAA;AAFF;AAIE;ECrBD,aAAA;EACA,sBAAA;EACA,uBDoBsB;ECnBtB,mBDmB8B;EAC5B,YAAA;AACH;AAEE;EACC,WAAA;EACA,WAAA;EC5BF,aAAA;EACA,sBAAA;EACA,2BD2BsB;EC1BtB,uBD0BkC;AAGnC;AAAE;ECtCD,aAAA;EACA,uBDsCgB;ECrChB,mBDqCwB;AAIzB;;AACA;EACC,WAAA;AAED;;AACA;EACC,WAAA;AAED;;AACA;EACC,sBAAA;AAED;;AAEC;EACC,6BAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;AACF","sourcesContent":["@import '../../sass/globals/globals.scss';\n@import '../../sass/globals/mixins.scss';\n\n.modal-option-value {\n\t@include flex(center, flex-start);\n\tflex: 1;\n\theight: 100%;\n\tbox-sizing: border-box;\n\toverflow: scroll;\n\n\t&-title {\n\t\tfont-size: 1.25em;\n\t\tfont-weight: bold;\n\t}\n\n\t&-container {\n\t\tflex: 1;\n\t\tmargin-top: 2em;\n\t\tmargin-inline: 2em;\n\t\tpadding: 2em;\n\t\tborder-radius: 1em;\n\t\tbackground-color: $white;\n\t}\n\n\t&-form {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\n\t\t&-layout {\n\t\t\t@include flexColumn(center, center);\n\t\t\tpadding: 1em;\n\t\t}\n\n\t\t&-radio-group {\n\t\t\twidth: 100%;\n\t\t\tmargin: 1em;\n\t\t\t@include flexColumn(flex-start, flex-start);\n\t\t}\n\n\t\t&-radio {\n\t\t\t@include flex(center, center);\n\t\t}\n\t}\n}\n\n.form-check {\n\tmargin: 1em;\n}\n\n.link-content-container{\n\twidth: 100%;\n}\n\n.modal-option-value-form-select{\n\twidth: 100% !important;\n}\n\n.modal-header {\n\t.form-action {\n\t\tmargin-inline: 1em !important;\n\t\twidth: 1em;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t}\n}","@mixin flex($justify-content, $align-items) {\n\tdisplay: flex;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n\n@mixin flexColumn($justify-content, $align-items) {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n","$dark-red: #8f003c;\n$sidebar-selected-color: #c4145d;\n$sidebar-logo-color: #a53363;\n$logo-color: #920942;\n$white: #fff;\n$grey: #f3f6f9;\n$grey2: #e2e5e7;\n$dark-grey: #777776;\n$font-color: #fff;\n$shadow-color: #4e7da2;\n$font: 'Rubik';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
